window.addEventListener('facetwp-loaded', () => {
  const clearBtns = document.querySelectorAll('.clearFacets');
  const FWP = window.FWP;

  if (0 < clearBtns.length) {
    clearBtns.forEach((clearBtn) => {
      clearBtn.addEventListener('click', () => {
        FWP.reset();
      });
    });
  }
});
